// extracted by mini-css-extract-plugin
module.exports = {"videoPlayButton":"VideoPlayButton_videoPlayButton__D4FZ4","looksOn":"VideoPlayButton_looksOn__eorOS","playIcon":"VideoPlayButton_playIcon__U4NLj"};